module.exports = __webpack_public_path__ + "images/illos.2115ef449c35c60bbc99.png";